/**
 * Подсказка «Вы в Москве? → перейти на московскую версию» (components/GeoRegionHint)
 * и кука region_choice. Чистые функции — тестируются в tests/geo.test.js.
 */
import { regionalizePath } from '../config/branches-config';
import { getCookieDomain } from '../config/site-host-env';
import { REGION_CHOICE_COOKIE, REGION_CHOICE_MAX_AGE, isCrawlerUserAgent, parseRegionChoice } from './geo-headers';

/** Показывать ли подсказку: регион известен, отличается от филиала страницы, выбора ещё не было, не робот. */
export function shouldShowGeoHint({
    geoBranch,
    currentBranch,
    choice,
    userAgent,
}: {
    geoBranch?: string | null;
    currentBranch: string;
    choice?: string | null;
    userAgent?: string | null;
}): boolean {
    const target = parseRegionChoice(geoBranch);
    if (!target || target === currentBranch) return false;
    if (parseRegionChoice(choice)) return false;
    if (isCrawlerUserAgent(userAgent)) return false;
    return true;
}

/**
 * Тот же путь в филиале targetCode: в path-режиме /geo/msk/<путь>, в host-режиме
 * https://msk.kontinental.pro/<путь> (и обратно на главный хост для spb).
 */
export function geoHintTargetUrl(publicPath: string, search: string, targetCode: string, fromCode: string): string {
    const target = regionalizePath(publicPath || '/', targetCode, fromCode);
    const query = search && search !== '?' ? (search.startsWith('?') ? search : `?${search}`) : '';
    return target.includes('?') ? target : `${target}${query}`;
}

/** Строка Set-Cookie / document.cookie для region_choice (180 дней, SameSite=Lax). */
export function regionChoiceCookie(code: string, { domain, secure }: { domain?: string; secure?: boolean } = {}): string {
    const parts = [
        `${REGION_CHOICE_COOKIE}=${encodeURIComponent(code)}`,
        'Path=/',
        `Max-Age=${REGION_CHOICE_MAX_AGE}`,
        'SameSite=Lax',
    ];
    if (domain) parts.push(`Domain=${domain}`);
    if (secure) parts.push('Secure');
    return parts.join('; ');
}

/** Запомнить выбор региона в браузере (на COOKIE_DOMAIN — общий для поддоменов). */
export function rememberRegionChoice(code: string): void {
    if (typeof document === 'undefined' || !parseRegionChoice(code)) return;
    try {
        document.cookie = regionChoiceCookie(code, {
            domain: getCookieDomain(),
            secure: typeof location !== 'undefined' && location.protocol === 'https:',
        });
    } catch {
        /* куки запрещены — подсказка просто покажется снова */
    }
}
